export default __webpack_public_path__ + "static/media/ng.0d0edb99.svg";